export default [
    {
        name: 'error',
        path: '/error',
        component: ( ) => import('@/views/error/ErrorView.vue')
    },

    {
        name: 'error-403',
        path: '/error-403',
        component: ( ) => import('@/views/error/ErrorView403.vue')
    },

    {
        name: 'error-maintenance-mode',
        path: '/maintenance-mode',
        component: ( ) => import('@/views/error/MaintenanceModeView.vue')
    }
]